import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const SectionNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const categories = [
    {
      id: 'hero',
      icon: '🎯',
      label: 'Hero Section',
      color: 'bg-purple-100 text-purple-800 border-purple-300',
      sections: [
        { name: 'Main Hero', scrollTo: 0 },
        { name: 'Use Your Voice Demo', scrollTo: 600 }
      ]
    },
    {
      id: 'story',
      icon: '📖',
      label: 'Story',
      color: 'bg-orange-100 text-orange-800 border-orange-300',
      sections: [
        { name: 'Problem Section', scrollTo: 1400 },
        { name: 'Our Story', scrollTo: 5200 }
      ]
    },
    {
      id: 'social-proof',
      icon: '⭐',
      label: 'Social Proof',
      color: 'bg-green-100 text-green-800 border-green-300',
      sections: [
        { name: 'Testimonials', scrollTo: 4500 },
        { name: 'Company Logos', scrollTo: 5400 },
        { name: 'Research Insight', scrollTo: 4800 }
      ]
    },
    {
      id: 'ai-advantage',
      icon: '🤖',
      label: 'AI Advantage',
      color: 'bg-blue-100 text-blue-800 border-blue-300',
      sections: [
        { name: 'Video Demo', scrollTo: 2400 },
        { name: 'How It Works', scrollTo: 2800 },
        { name: 'Audit Trail', scrollTo: 3500 },
        { name: 'Before/After', scrollTo: 4000 }
      ]
    },
    {
      id: 'pricing',
      icon: '💰',
      label: 'Pricing',
      color: 'bg-pink-100 text-pink-800 border-pink-300',
      sections: [
        { name: 'ROI Calculator', scrollTo: 5800 }
      ]
    }
  ];

  const scrollToSection = (position) => {
    window.scrollTo({ top: position, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-text-primary text-white rounded-full p-4 shadow-lg hover:scale-110 transition-all flex items-center gap-2"
      >
        <span className="text-sm font-medium hidden sm:inline">Section Guide</span>
        {isOpen ? <ChevronDown className="w-5 h-5" /> : <ChevronUp className="w-5 h-5" />}
      </button>

      {/* Navigation Panel */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-2xl border border-border-light p-4 w-80 max-h-96 overflow-y-auto">
          <h3 className="heading-3 text-sm mb-4">Landing Page Structure</h3>
          
          <div className="space-y-3">
            {categories.map((category) => (
              <div key={category.id} className="border-b border-border-light pb-3 last:border-0">
                <div className={`inline-flex items-center gap-2 px-2 py-1 rounded-full border text-xs font-medium ${category.color} mb-2`}>
                  <span>{category.icon}</span>
                  <span>{category.label}</span>
                </div>
                
                <div className="space-y-1 ml-2">
                  {category.sections.map((section, idx) => (
                    <button
                      key={idx}
                      onClick={() => scrollToSection(section.scrollTo)}
                      className="block w-full text-left text-xs text-text-muted hover:text-text-primary hover:bg-bg-section px-2 py-1 rounded transition-colors"
                    >
                      → {section.name}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-4 pt-3 border-t border-border-light">
            <p className="caption text-text-muted text-center">
              ✅ All 5 categories covered
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionNav;
